export default __webpack_public_path__ + "static/media/alpinelinux.9d1f4706.svg";